import { formatMoney } from '../helpers'

export const templateCustomerDiscountItem = async ({ key, title, amount }) => {
  return `
    <li class="discounts-list__item" data-key="${key}">
      <span class="discounts-list__item-label">${title} <button data-discount-code-remove>&times;</button></span>
      <span class="discounts-list__item-amount">- ${formatMoney(amount)}</span>
    </li>
  `
}

export const templateDiscountItem = async ({ key, title, amount }) => {
  return `
    <li class="discounts-list__item" data-key="${key}">
      <span class="discounts-list__item-label">${title}</span>
      <span class="discounts-list__item-amount">- ${formatMoney(amount)}</span>
    </li>
  `
}
